import DashBigNumbers from "./tabs/DashBigNumbers.vue";
import DashUsers from "./tabs/DashUsers.vue";
import DashAppointments from "./tabs/DashAppointments.vue";
import DashKpis from "./tabs/DashKpis.vue";
import DashFinancial from "./tabs/DashFinancial.vue";

export default {
  name: "Home",
  components: {
    DashBigNumbers,
    DashUsers,
    DashAppointments,
    DashKpis,
    DashFinancial,
  },
  mounted() {
    this.loadTab("big");
  },
  data() {
    return {
      activeTab: "big",
      tabs: [
        { id: "big", label: "Big Numbers", icon: "fa-solid fa-chart-simple", fetch: "bigNumbers" },
        { id: "users", label: "Usuários", icon: "fa-solid fa-users", fetch: "users" },
        { id: "appointments", label: "Consultas", icon: "far fa-calendar-check", fetch: "appointments" },
        { id: "kpis", label: "Outros KPIs", icon: "fa-solid fa-gauge-high", fetch: "kpis" },
        { id: "financial", label: "Financeiro", icon: "fa-solid fa-dollar-sign", fetch: "financial" },
      ],
      loading: {
        big: false,
        users: false,
        appointments: false,
        kpis: false,
        financial: false,
      },
      errored: {
        big: false,
        users: false,
        appointments: false,
        kpis: false,
        financial: false,
      },
      data: {
        big: null,
        users: null,
        appointments: null,
        kpis: null,
        financial: null,
      },
    };
  },
  methods: {
    selectTab(id) {
      this.activeTab = id;
      this.loadTab(id);
    },
    async loadTab(id) {
      if (this.data[id] || this.loading[id]) return;
      const tab = this.tabs.find((t) => t.id === id);
      this.$set(this.loading, id, true);
      this.$set(this.errored, id, false);
      try {
        const res = await this.$dashboardService[tab.fetch]();
        this.$set(this.data, id, res.data || {});
      } catch (e) {
        console.error("Erro ao carregar dashboard:", id, e);
        this.$set(this.errored, id, true);
      } finally {
        this.$set(this.loading, id, false);
      }
    },
    retryTab(id) {
      this.$set(this.data, id, null);
      this.loadTab(id);
    },
  },
};
